import {
    useEffect,
    useState,
} from 'react';

// FNP-1192 — the keyword search, module-scoped for the same reason the zones
// module's is (FNP-815): the search input lives inside the table component and
// the hook that filters on the keyword is a different component. A local
// useState would give each its own copy and search would silently do nothing.
//
// Do not replace with a local useState.
//
// ⚠️ THE KEYWORD IS CLIENT-SIDE, THE TYPE FILTER IS NOT, and the two are not
// interchangeable. The schema's `name` filter is an EXACT match — useless for
// someone scanning a zone, who wants "show me anything with `mail` in it". So
// the keyword narrows the LOADED WINDOW client-side, exactly as the zones
// module does, while the type filter goes to the server. The footer says which
// scope a count refers to.
let globalKeyword = '';
const keywordListeners: Set<(keyword: string) => void> = new Set();

const notifyKeywordChange = (keyword: string) => {
    globalKeyword = keyword;
    keywordListeners.forEach(listener => listener(keyword));
};

// Test-only reset. The store outlives a component tree by design, which means
// it also outlives a test case — without this, a keyword set in one test leaks
// into the next.
export const resetDnsRecordsSearch = () => {
    globalKeyword = '';
    keywordListeners.clear();
};

export const useDnsRecordsSearch = () => {
    const [keyword, setKeyword] = useState<string>(globalKeyword);

    useEffect(() => {
        const listener = (newKeyword: string) => {
            setKeyword(newKeyword);
        };
        keywordListeners.add(listener);
        // A consumer mounting after the keyword was set must not start from ''.
        setKeyword(globalKeyword);
        return () => {
            keywordListeners.delete(listener);
        };
    }, []);

    return {
        keyword,
        handleFilterByKeyword: (newKeyword: string) => notifyKeywordChange(newKeyword),
    };
};
